import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import HttpBackend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import {
  localizationBackend,
  localizationProjectId,
  supportedLngs,
} from "./localization/options";

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    supportedLngs,
    fallbackLng: "en",
    // Browsers report regioned codes ("fr-FR", "de-DE") while supportedLngs holds
    // bare ones ("fr", "de"). Without this flag the detector rejects every regioned
    // navigator language and falls back to English, so a French client opening a
    // French coach's checkout landed on an English payment page (reported by a
    // coach on 2026-08-29). The main app has always set it; this app missed it.
    nonExplicitSupportedLngs: true,
    interpolation: {
      escapeValue: false,
    },
    backend: {
      loadPath: import.meta.env.DEV
        ? `${localizationBackend}?projectId=${localizationProjectId}&lang={{lng}}`
        : "/_locales/{{lng}}.json",
    },
    detection: {
      // querystring first so a coach can pin the language of a link they share:
      // ?locale=fr wins over whatever the visitor's browser claims.
      order: ["querystring", "navigator", "htmlTag"],
      lookupQuerystring: "locale",
      caches: [],
    },
  });

/**
 * The document's own language follows the reader's.
 *
 * `<html lang>` is what a screen reader picks its voice from and what a browser offers to
 * translate against, and this app's language is decided at runtime by the query string or the
 * browser, never at build time. So the tag is set on every change rather than baked into
 * index.html.
 */
i18n.on("languageChanged", (lng) => {
  document.documentElement.lang = lng;
});
if (i18n.language) document.documentElement.lang = i18n.language;

export default i18n;
